import React, {useRef} from "react"
import ButtonTemplate from "./buttons/ButtonTemplate"

export const widgetImportFileButtonPrototype = [
        "buttonicons",
        {
          "key": "action",
          "type": "STRING",
          "label": "Aktion",
          "size": 3
        }
      ]

const ImportFileButtonWidget = ({widget, triggerAction}) => {
    const {label, action, startIcon, endIcon, variant} = widget
    const hiddenFileInputRef = useRef(null)
    const onFileChange = event => {
        const file = event.target.files[0]
        triggerAction(action, file)
    }
    const openFileImport = () => {
        hiddenFileInputRef?.current?.click()
    }

    return (
        <>
            <ButtonTemplate
                widget={widget}
                buttonText={label}
                startIcon={startIcon}
                endIcon={endIcon}
                variant={variant}
                onClick={openFileImport}
            />
            <input
                type="file"
                onChange={onFileChange}
                ref={hiddenFileInputRef}
                style={{display: "none"}}
            />
        </>
    )
}

export default ImportFileButtonWidget
